import { colors, fontSize, radius, spacing } from '../../styles/theme'

/** Shown on template pages in the Live workspace, which only ever displays promoted versions. */
export default function LiveReadOnlyBanner() {
  return (
    <div role="note" data-testid="live-readonly-banner" style={{
      background: colors.infoLight, color: colors.info,
      border: `1px solid ${colors.infoBorder}`, borderRadius: radius.sm,
      padding: `${spacing.sm} ${spacing.md}`, fontSize: fontSize.sm, marginBottom: spacing.md,
    }}>
      Live workspace is read-only. Make changes in Test and promote a version.
    </div>
  )
}
